/**
 * The period tabs over a list read through `rangeFor` (operatorFormat.js) —
 * the operator's Assignments and the dispatch board. A segmented group of
 * toggle buttons; `aria-pressed` marks the chosen one.
 *
 * `options` is `[{ key, label }]` (operatorFormat's `rangeOptions`).
 *
 * `busy` is "the period you just tapped is still on the wire". It draws a
 * slim bar along the bottom edge of the group — under the finger that
 * tapped, which is where the answer to "did that register?" belongs — and
 * says as much to a screen reader. The bar is positioned absolutely inside
 * the group's own clipped box, so it costs NO layout: a fast answer is a
 * flicker rather than a jump, which is why neither screen bothers to delay
 * showing it.
 *
 * It is deliberately NOT a disabled state. Both screens guard their reads
 * with a `latestLoad` ticket — only the newest answer is allowed to land —
 * so a second tap mid-flight simply wins, and four tabs that went dead
 * under the thumb while a slow read ran would be the worse of the two.
 */
import React from 'react';

export default function RangeTabs({
  options, value, onChange, busy = false,
}) {
  return (
    <div className="pp-op-segmented" role="group" aria-label="Period" aria-busy={busy}>
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          className={`pp-op-segmented__option${option.key === value ? ' is-active' : ''}`}
          aria-pressed={option.key === value}
          onClick={() => onChange(option.key)}
        >
          {option.label}
        </button>
      ))}
      {busy ? (
        <span className="pp-op-segmented__bar" role="status">
          <span className="visually-hidden">Loading this period…</span>
        </span>
      ) : null}
    </div>
  );
}
